import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: flex-end;
  margin-bottom: 16px;
  margin-top: -55px;
`;

export { HeaderWrapper, Wrapper };
